<section>
  <ngb-rating [(rate)]="currentRate"></ngb-rating>
  <hr />
  <pre>Rate: <strong>{{currentRate}}</strong></pre>
</section>
